var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirmwareIconBlack = function SvgFirmwareIconBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#131B20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.262 20.25V17a.75.75 0 0 0-.75-.75h-3.25M4.75 3.75V7c0 .414.336.75.75.75h3.25m-4.936 3.219A8.25 8.25 0 0 0 12 20.25 8.4 8.4 0 0 0 18.632 17m1.554-3.969q.064-.507.064-1.031A8.25 8.25 0 0 0 12 3.75 8.4 8.4 0 0 0 5.368 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131B20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 12.75 11.25 15 15 9"
  })));
};
export { SvgFirmwareIconBlack as ReactComponent };
export default __webpack_public_path__ + "3ac060770f2bf96e12a8fbf8d5bda464.svg";